<template>
    <div class="language-select-container customMultiselectCommon" v-if="selectedLanguage">
        <!-- <div v-if="translatedLang" class="mb-1">
            {{ translatedLang["Select Language"][selectedLanguage.key] || "Select Language" }}
        </div> -->
        <!-- <select v-model="changeLang" @change="handleLangChange" class="language-select">
            <option v-for="lang in Languages" :key="lang.key" :value="lang.key">
                {{ lang.flag }} {{ lang.value }}
            </option>
        </select> -->
        <multiselect v-model="changeLang" :options="Languages" label="value" track-by="key" :searchable="false"
            :close-on-select="true" :allow-empty="false" :custom-label="customLangLabel" placeholder="Select Language" :multiple="false" :showLabels="false"
            @input="handleLangChange" class="language-select" />
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Multiselect from "vue-multiselect";

export default {
    name: "LanguageSelect",
    components: {
        Multiselect
    },
    data() {
        return {
            Languages: [
                { key: "en", value: "English", flag: "🇬🇧" },
                // { key: "sp", value: "Spanish", flag: "🇪🇸" },
                // { key: "fr", value: "French", flag: "🇫🇷" },
                // { key: "ge", value: "German", flag: "🇩🇪" },
                { key: "ar", value: "Arabic", flag: "🇦🇪" },
            ],
            changeLang: { key: "en", value: "English", flag: "🇬🇧" },
        };
    },
    computed: {
        ...mapState("DemoStore", ["selectedLanguage", "translatedLang"])
    },
    methods: {
        ...mapActions("DemoStore", ["setSelectedLanguage", "initializeTranslation"]),
        handleLangChange() {
            this.setSelectedLanguage(this.changeLang);
            this.initializeTranslation();
        },
        customLangLabel(option) {
            return `${option.flag} ${option.value}`
        }
    },
    mounted() {
        this.changeLang = this.selectedLanguage || 'en';
        this.initializeTranslation();
    }
};
</script>

<style scoped>
.language-select-container {
    position: absolute;
    top: 15px;
    right: 20px;
    z-index: 100;
    width: 140px;
}

/* .language-select {
    padding: 8px 32px 8px 12px;
    border: 1px solid #e4edee;
    border-radius: 8px;
    font-family: 'Poppins';
    font-size: 14px;
    color: #065559;
    background-color: white;
    cursor: pointer;
    min-width: 160px;
}

.language-select:focus {
    outline: none;
    border-color: #065559;
} */
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>